document.addEventListener("DOMContentLoaded", function () {
  initProductMediaGrouping();
  initVariantScrollPin();
});

// Bug fix: switching product variant made the media gallery jump to the top of
// the viewport. On variant change two independent code paths re-render the
// gallery and both call splide.refresh()/go(0) (the theme's variant-select.js
// `updateMultiMediaWithVariant` and our wim-product.js `filterByGroup`). Splide's
// refresh/go moves focus and reflows the gallery, scrolling the page up.
//
// All of that work is deferred (setTimeout/fetch) past the user's click, so the
// robust fix is to capture the scroll position the instant a variant option is
// changed and re-assert it for a short window covering the async re-render.
// We abort the moment the user scrolls on purpose, so we never fight them.
function wimPinScroll(durationMs) {
  const targetX = window.scrollX;
  const targetY = window.scrollY;
  const start = performance.now();
  let aborted = false;

  const SCROLL_KEYS = [32, 33, 34, 35, 36, 38, 40]; // space, pageup/down, end, home, arrows

  function cleanup() {
    window.removeEventListener("wheel", abort);
    window.removeEventListener("touchmove", abort);
    window.removeEventListener("keydown", onKey);
  }
  function abort() {
    aborted = true;
    cleanup();
  }
  function onKey(e) {
    if (SCROLL_KEYS.indexOf(e.keyCode) !== -1) abort();
  }

  window.addEventListener("wheel", abort, { passive: true });
  window.addEventListener("touchmove", abort, { passive: true });
  window.addEventListener("keydown", onKey);

  function frame(now) {
    if (aborted) return;
    if (window.scrollX !== targetX || window.scrollY !== targetY) {
      window.scrollTo(targetX, targetY);
    }
    if (now - start < durationMs) {
      requestAnimationFrame(frame);
    } else {
      cleanup();
    }
  }
  requestAnimationFrame(frame);
}

// Capture the scroll position the moment a variant option (radio swatch or
// select) is changed — before any of the deferred gallery re-rendering runs.
function initVariantScrollPin() {
  if (window.__wimVariantScrollPinReady) return;
  window.__wimVariantScrollPinReady = true;

  document.addEventListener(
    "change",
    function (e) {
      const t = e.target;
      if (!t || !t.matches) return;
      const isVariantInput =
        t.matches("input.input-radio") ||
        t.matches("[data-option-name] input, [data-option-name] select") ||
        !!t.closest("[data-option-name]");
      if (!isVariantInput) return;
      // ~700ms comfortably covers the cached re-render (setTimeout 0) and a
      // fast network section fetch; aborts instantly if the user scrolls.
      wimPinScroll(700);
    },
    true, // capture phase: run before the theme's bubbling listeners
  );
}

document.addEventListener("wim:subscription-changed", function (e) {
  var isSubscription = e.detail.isSubscription;
  document.querySelectorAll(".wim-suscription-label").forEach(function (el) {
    el.classList.toggle("hidden", !isSubscription);
  });
});

function initProductMediaGrouping() {
  document.querySelectorAll('[id^="stacked-"]').forEach(function (stacked) {
    if (stacked.id.indexOf("stacked-zoom-") === 0) return;

    const sectionId = stacked.id.slice("stacked-".length);

    // Grupo de medios activo (featured_media.id de la variante seleccionada).
    // Es la UNICA fuente de verdad: cualquier re-aplicacion diferida usa este
    // valor y nunca "el primer medio visible". Antes, el MutationObserver
    // reprogramaba con getActiveGroupId() (= primer visible), asi que cuando dos
    // caminos distintos pedian grupos diferentes en el mismo tick (el tema
    // prepend-ea la imagen de la variante ANTERIOR desde updateActiveMedia() y
    // el `change` aplica la nueva) el primer visible alternaba en cada frame y
    // el bucle rAF/timeout -> insertBefore -> observer -> rAF no terminaba
    // nunca (parpadeo/salto de la galeria y, con observers de apps de terceros
    // encima, la pestana se congelaba). ClickUp 869euvd9v.
    let activeGroupId = null;
    let enforcing = false;
    let pendingFrames = [];
    let pendingTimeout = null;
    let observer = null;

    // Cortafuegos: si por lo que sea se re-aplica mas de N veces por segundo,
    // dejamos de reprogramar en vez de bloquear el hilo principal.
    const MAX_ENFORCES_PER_SECOND = 20;
    let enforceWindowStart = 0;
    let enforceCount = 0;

    // Copia data-media-group desde cada elemento del stacked a su slide Splide equivalente
    function syncGroupsToSplide() {
      const splideList = document.getElementById("media_product-" + sectionId);
      if (!splideList) return;

      stacked
        .querySelectorAll("[data-media-group]")
        .forEach(function (stackedEl) {
          const mediaId = stackedEl.dataset.mediaId;
          const slides = splideList.querySelectorAll(
            '[data-media-id="' + mediaId + '"]',
          );
          slides.forEach(function (slideEl) {
            if (slideEl.dataset.mediaGroup !== stackedEl.dataset.mediaGroup) {
              slideEl.dataset.mediaGroup = stackedEl.dataset.mediaGroup;
            }
            if (slideEl.dataset.index !== stackedEl.dataset.index) {
              slideEl.dataset.index = stackedEl.dataset.index;
            }
            slideEl.toggleAttribute(
              "data-wim-highlight",
              stackedEl.hasAttribute("data-wim-highlight"),
            );
            slideEl.toggleAttribute(
              "data-wim-hero",
              stackedEl.hasAttribute("data-wim-hero"),
            );
          });
        });
    }

    function getMediaIndex(el) {
      const index = parseInt(el.dataset.index || el.getAttribute("index"), 10);
      return isNaN(index) ? Number.MAX_SAFE_INTEGER : index;
    }

    function getMediaPriority(el) {
      if (el.hasAttribute("data-wim-highlight")) return 0;
      if (el.hasAttribute("data-wim-hero")) return 1;
      return 2;
    }

    function sortMediaEls(a, b) {
      const priorityDiff = getMediaPriority(a) - getMediaPriority(b);
      if (priorityDiff !== 0) return priorityDiff;
      return getMediaIndex(a) - getMediaIndex(b);
    }

    // Solo toca el DOM cuando hace falta: cada mutacion inutil despierta a los
    // MutationObserver globales de las apps (traduccion, upsell...) y al de
    // Alpine, y eso es trabajo en el hilo principal en pleno cambio de variante.
    function setDisplay(el, value) {
      if (el.style.display === value) return false;
      el.style.display = value;
      return true;
    }

    function setClass(el, className, on) {
      if (el.classList.contains(className) === on) return false;
      el.classList.toggle(className, on);
      return true;
    }

    // Reordena fisicamente (DOM) los medios del grupo activo al frente del
    // contenedor, en orden de prioridad/indice. NO usamos CSS `order`: Splide
    // posiciona los slides por su indice en el DOM + translate del track, asi
    // que un `order` de flexbox descoloca los slides respecto a donde Splide
    // desplaza el carrusel (slides en blanco al hacer swipe, imagenes que
    // "desaparecen"). El orden del DOM es la unica fuente de verdad.
    // Excluimos los clones de Splide: se regeneran en cada refresh() a partir
    // de los slides reales, por lo que solo deben reordenarse estos.
    // Devuelve true si ha movido algo.
    function reorderGroupFirst(container, groupId) {
      if (!container || !groupId) return false;

      const groupEls = Array.from(
        container.querySelectorAll('[data-media-group="' + groupId + '"]'),
      )
        .filter(function (el) {
          return (
            el.parentElement === container &&
            !el.classList.contains("splide__slide--clone")
          );
        })
        .sort(sortMediaEls);

      let moved = false;
      groupEls.forEach(function (el, index) {
        const currentEl = container.children[index];
        if (currentEl !== el) {
          container.insertBefore(el, currentEl || null);
          moved = true;
        }
      });
      return moved;
    }

    function getVisibleGroupId() {
      const visibleMedia = Array.from(
        stacked.querySelectorAll("[data-media-group]"),
      ).find(function (el) {
        return el.style.display !== "none";
      });
      return visibleMedia && visibleMedia.dataset.mediaGroup;
    }

    // Filtra desktop (display), thumbnails mobile y splide slides por groupId.
    // Idempotente: si el DOM ya esta como debe, no genera ninguna mutacion.
    // Devuelve true si ha cambiado algo.
    function filterByGroup(groupId) {
      if (!groupId) return false;
      let changed = false;

      changed = reorderGroupFirst(stacked, groupId) || changed;

      stacked.querySelectorAll("[data-media-group]").forEach(function (el) {
        const show = String(el.dataset.mediaGroup) === String(groupId);
        changed = setDisplay(el, show ? "" : "none") || changed;
      });

      const thumbnailEl = document.getElementById(
        "x-product-thumbnail-" + sectionId,
      );
      if (thumbnailEl) {
        changed =
          reorderGroupFirst(thumbnailEl.firstElementChild, groupId) || changed;
        thumbnailEl
          .querySelectorAll("[data-media-group]")
          .forEach(function (thumb) {
            const show = String(thumb.dataset.mediaGroup) === String(groupId);
            changed = setDisplay(thumb, show ? "" : "none") || changed;
          });
      }

      const splideEl = document.getElementById("x-product-" + sectionId);
      const splideList = document.getElementById("media_product-" + sectionId);
      if (splideList) {
        let splideChanged = reorderGroupFirst(splideList, groupId);
        const hasGroupedSlides =
          !!splideList.querySelector("[data-media-group]");
        splideList.querySelectorAll("[data-media-id]").forEach(function (el) {
          const mediaGroup = el.dataset.mediaGroup;
          const shouldShow =
            hasGroupedSlides &&
            !!mediaGroup &&
            String(mediaGroup) === String(groupId);
          splideChanged = setDisplay(el, shouldShow ? "" : "none") || splideChanged;
          splideChanged = setClass(el, "splide__slide", shouldShow) || splideChanged;
          splideChanged = setClass(el, "media_active", shouldShow) || splideChanged;
        });
        if (splideChanged && splideEl && splideEl.splide) {
          splideEl.splide.refresh();
          splideEl.splide.go(0);
          requestAnimationFrame(function () {
            const xv = window.Alpine?.store?.("xVideo");
            if (!xv) return;
            xv.pauseResetAllHighlightNativeInRoot(splideEl);
            xv.replayActiveSlideHighlightNative(splideEl);
          });
        }
        changed = splideChanged || changed;
      }

      // Filter zoom stacked (enlarge mode)
      const zoomStackedEl = document.getElementById(
        "stacked-zoom-" + sectionId,
      );
      if (zoomStackedEl) {
        zoomStackedEl
          .querySelectorAll("[data-media-group]")
          .forEach(function (el) {
            const show = String(el.dataset.mediaGroup) === String(groupId);
            changed = setDisplay(el, show ? "" : "none") || changed;
          });
      }

      // Navigate zoom Splide (gallery/carousel mode)
      const zoomSplideEl = document.getElementById(
        "media-gallery-" + sectionId,
      );
      if (zoomSplideEl && zoomSplideEl.splide) {
        let zoomChanged = reorderGroupFirst(
          zoomSplideEl.querySelector(".splide__list"),
          groupId,
        );
        const hasGroupedZoomSlides =
          !!zoomSplideEl.querySelector("[data-media-group]");
        zoomSplideEl.querySelectorAll("[data-media-id]").forEach(function (el) {
          const mediaGroup = el.dataset.mediaGroup;
          const shouldShow =
            hasGroupedZoomSlides &&
            !!mediaGroup &&
            String(mediaGroup) === String(groupId);
          zoomChanged = setDisplay(el, shouldShow ? "" : "none") || zoomChanged;
          zoomChanged = setClass(el, "splide__slide", shouldShow) || zoomChanged;
          zoomChanged = setClass(el, "media_active", shouldShow) || zoomChanged;
        });
        if (zoomChanged) {
          zoomSplideEl.splide.refresh();
          // reorderGroupFirst() ya dejo el primer medio del grupo activo al
          // frente del DOM, y refresh() reindexa Splide segun ese nuevo orden.
          // Por eso vamos a go(0) (igual que la galeria principal) en lugar de
          // usar el atributo `index` del render original, que tras el reordenado
          // apunta a un slide distinto/equivocado o en blanco.
          zoomSplideEl.splide.go(0);
        }
        changed = zoomChanged || changed;
      }

      return changed;
    }

    function cancelScheduled() {
      pendingFrames.forEach(function (id) {
        cancelAnimationFrame(id);
      });
      pendingFrames = [];
      if (pendingTimeout) {
        clearTimeout(pendingTimeout);
        pendingTimeout = null;
      }
    }

    // Aplica el grupo activo. Nuestras propias mutaciones se descartan del
    // observer con takeRecords() para que no se re-disparen a si mismas.
    function runEnforce() {
      if (!activeGroupId || enforcing) return;
      enforcing = true;
      try {
        filterByGroup(activeGroupId);
      } finally {
        if (observer) observer.takeRecords();
        enforcing = false;
      }
    }

    // Version para las re-aplicaciones diferidas (rAF/timeout/observer): pasa
    // por el cortafuegos. La aplicacion directa tras un clic (applyGroup) no,
    // para que un cambio de color nunca se quede sin aplicar.
    function enforceGroupOrder() {
      const now = performance.now();
      if (now - enforceWindowStart > 1000) {
        enforceWindowStart = now;
        enforceCount = 0;
      }
      if (++enforceCount > MAX_ENFORCES_PER_SECOND) {
        cancelScheduled();
        return;
      }
      runEnforce();
    }

    // Re-aplica el grupo activo tras los re-renders diferidos del tema
    // (variant-select.js hace prepend de la featured image en setTimeout/fetch).
    // Cancela lo pendiente: solo puede haber UNA cola, siempre para activeGroupId.
    function scheduleGroupOrder() {
      if (!activeGroupId) return;
      cancelScheduled();
      pendingFrames.push(
        requestAnimationFrame(function () {
          enforceGroupOrder();
          pendingFrames.push(requestAnimationFrame(enforceGroupOrder));
        }),
      );
      pendingTimeout = setTimeout(enforceGroupOrder, 250);
    }

    function applyGroup(groupId) {
      if (!groupId) return;
      activeGroupId = String(groupId);
      runEnforce();
      scheduleGroupOrder();
    }

    // Al arrancar el Splide: sincronizar grupos y aplicar filtro inicial
    document.addEventListener(
      "eurus:media-gallery-ready:" + sectionId,
      function () {
        syncGroupsToSplide();
        const groupId = activeGroupId || getVisibleGroupId();
        if (groupId) {
          // setTimeout(0) para ejecutar despues de los listeners del tema (p.ej. _updateMedia que llama splide.go(0))
          setTimeout(function () {
            applyGroup(groupId);
          }, 0);
        }
      },
      { once: true },
    );

    // Bootstrap de seguridad: cuando la PDP carga con ?variant= puede no dispararse
    // el flujo esperado a tiempo. Sincronizamos y filtramos una vez al inicio.
    syncGroupsToSplide();
    const initialGroupId = getVisibleGroupId();
    if (initialGroupId) {
      applyGroup(initialGroupId);
    }

    // Cualquier mutacion EXTERNA del stacked (el tema mueve la featured image,
    // Alpine re-renderiza...) re-aplica el grupo activo. Las nuestras se
    // descartan en enforceGroupOrder() con takeRecords().
    observer = new MutationObserver(function () {
      if (enforcing) return;
      scheduleGroupOrder();
    });
    observer.observe(stacked, { childList: true });

    // Cambio de swatch de color
    document.addEventListener("change", function (e) {
      if (!e.target.matches("input.input-radio")) return;
      const label = document.querySelector(
        '[data-media-group-id][for="' + e.target.id + '"]',
      );
      if (label && label.dataset.mediaGroupId) {
        applyGroup(label.dataset.mediaGroupId);
      }
    });

    // Cambio de variante (llega con el HTML de la seccion renderizado en servidor)
    document.addEventListener(
      "eurus:product-page-variant-select:updated:" + sectionId,
      function (e) {
        const html = e.detail && e.detail.html;
        if (!html) return;

        // 1. Sincronizar display del stacked y zoom-stacked desde el HTML del servidor
        const fetchedStacked = html.getElementById("stacked-" + sectionId);
        if (!fetchedStacked) return;
        const fetchedZoomStacked = html.getElementById(
          "stacked-zoom-" + sectionId,
        );
        const currentZoomStacked = document.getElementById(
          "stacked-zoom-" + sectionId,
        );
        if (fetchedZoomStacked && currentZoomStacked) {
          fetchedZoomStacked
            .querySelectorAll("[data-media-group]")
            .forEach(function (fetchedEl) {
              const currentEl = currentZoomStacked.querySelector(
                '[data-media-id="' + fetchedEl.dataset.mediaId + '"]',
              );
              if (currentEl) setDisplay(currentEl, fetchedEl.style.display);
            });
        }
        fetchedStacked
          .querySelectorAll("[data-media-group]")
          .forEach(function (fetchedEl) {
            const mediaId = fetchedEl.dataset.mediaId;
            const currentEl = stacked.querySelector(
              '[data-media-id="' + mediaId + '"]',
            );
            if (currentEl) setDisplay(currentEl, fetchedEl.style.display);
          });
        syncGroupsToSplide();

        // 2. El grupo activo es el que el servidor deja visible para la variante
        const groupId = getVisibleGroupId();
        if (!groupId) return;

        // 3. Reaplica visibilidad y orden completos (stacked, slider principal, thumbs y zoom)
        applyGroup(groupId);
      },
    );
  });
}
